import { Box, Typography, useTheme } from "@mui/material";
import { keyframes } from "@mui/system";
import React from "react";

const typingKeyframes = keyframes({
  "0%": {
    transform: "translateY(0px)",
  },
  "25%": {
    transform: "translateY(0px)",
  },
  "35%": {
    transform: "translateY(15px)",
  },
  "45%": {
    transform: "translateY(0px)",
  },
  "60%": {
    transform: "translateY(-15px)",
  },
  "75%": {
    backgroundColor: "white",
    transform: "translateY(0px)",
  },
  "100%": {
    transform: "translateY(0px)",
  },
});

export interface TypingProps {
  containerWidth?: number;
}

export const Typing: React.FC<TypingProps> = ({ containerWidth = 400 }) => {
  const theme = useTheme();
  const maxBubbleWidth = Math.max(250, containerWidth - 100);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
        mb: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: `${maxBubbleWidth}px`,
          minWidth: "120px",
        }}
      >
        <Typography
          sx={{
            color: "rgba(0, 0, 0, 0.6)",
            fontSize: "11px",
            textAlign: "left",
            mb: 0.5,
          }}
        >
          Assistant is typing...
        </Typography>

        <Box
          sx={{
            alignItems: "center",
            backgroundColor: theme.palette.secondary.main,
            borderRadius: "0px 12px 12px 12px",
            display: "flex",
            padding: 2,
            width: "fit-content",
            minWidth: "80px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              width: 40,
            }}
          >
            <Box
              sx={{
                animation: `${typingKeyframes} 1.4s ease-in-out infinite`,
                animationDelay: "0s",
                backgroundColor: "#1976d2",
                borderRadius: "50%",
                height: 6,
                width: 6,
              }}
            />
            <Box
              sx={{
                animation: `${typingKeyframes} 1.5s linear infinite`,
                animationDelay: "0.2s",
                backgroundColor: "#006192",
                borderRadius: "100%",
                height: 8,
                width: 8,
              }}
            />
            <Box
              sx={{
                animation: `${typingKeyframes} 1.5s linear infinite`,
                animationDelay: "0.3s",
                backgroundColor: "#006192",
                borderRadius: "100%",
                height: 8,
                width: 8,
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Typing;
